import Vue from "vue";
import dayjs from "dayjs";

export function install(vue: typeof Vue): void {
  vue.filter("fullDate", (value) => {
    return dayjs(value).format("MMMM D, YYYY [at] hh:mm Z");
  });

  vue.filter("minutes", (value) => {
    if (typeof value !== "number") {
      return value;
    }

    return Math.floor(value / 60 / 1000);
  });
}
